<div class="ion-app frame">
  <ci-header class="mat-elevation-z8"></ci-header>
  <div
    class="container main"
    id="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
